<template>
    <div class="wrapper">
      <h2 class="mainTitle">任意门开发者使用提示及隐私政策</h2>
      <div class="content">
        <p>本政策仅适用于平安科技（深圳）有限公司，注册地为深圳市福田区福田街道福安社区益田路5033号平安金融中心23楼，（以下简称"我们"）面向开发者、最终用户研发和运营的任意门SDK产品（以下简称"任意门""本产品""产品""服务"）。</p>
        <p>任意门产品是可在第三方应用程序中使用的便捷的软件开发工具包（SDK）。第三方应用程序开发者（以下简称"开发者"）在其应用程序内集成任意门后，可通过任意门向其应用程序的最终用户（以下简称"最终用户""您"）提供本隐私政策所说明的功能及服务。</p>
        <p>发布日期：</p>
        <p>更新日期：2026年04月15日</p>
        <p>生效日期：2026年04月30日</p>
        <br/>
        <h3>版本更新说明：</h3>
        <p>我们对《任意门开发者使用提示及隐私政策》进行了更新，具体更新内容为：1、为实现保单打印功能，需查询并连接本地打印机设备。2、为提升理赔拍照质量，可在暗光环境下调用环境光传感器以自动开启闪光灯。</p>
        <br/>
        <p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
        <p>电子邮箱：PUB_KJRYMSDKZX@pingan.com.cn</p>
        <p>地址： 深圳市南山区高新园嘉联支付大厦6F</p>
        <br />
        <h3>本政策将帮助您了解以下内容：</h3>
        <h3>开发者使用提示</h3>
        <ol class="list">
          <li v-for="(item, index) in policyContent" :key="index">{{item}}</li>
        </ol>
        <p class="emphasis">附录：相关定义</p>
        <br/>
        <p>任意门产品和服务旨在为最终用户提供在开发者应用内便捷的跳转服务，使最终用户无需下载多个应用即可享受多种不同服务。开发者在其开发和/或运营的应用内集成任意门后，使用开发者应用的最终用户将可以在开发者应用内通过任意门功能访问其他第三方主体提供的服务。<span class="emphasis">在提供相关服务的过程中，我们可能会处理开发者应用的数据信息，其中可能包括开发者应用最终用户的个人信息。此开发者使用提示及隐私政策旨在帮助开发者及最终用户了解我们如何处理和保护最终用户的个人信息。</span></p>
        <p>我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。我们致力于维持用户对我们的信任，我们将恪守法律法规要求，按业界成熟的安全标准，采取安全保护措施来保护最终用户的个人信息。</p>
        <h3>请开发者和最终用户在使用我们的产品或服务前，仔细阅读并了解本开发者使用提示及隐私政策。</h3>
        <br />
        <h3>开发者使用提示：</h3>
        <ol class="list">
          <li>开发者应遵守个人信息有关的所有可适用法律、政策和法规，保护最终用户个人信息安全。</li>
          <li><span class="emphasis">开发者应当通过隐私政策、个人信息保护声明等形式向最终用户说明任意门的信息收集情况并征得最终用户的同意后初始化SDK，否则开发者不得使用任意门或应立即关闭任意门功能。</span></li>
          <li>开发者应向最终用户提供易于操作的访问、更正、删除其个人信息，撤销或更改其授权同意、注销其个人账号、个人信息迁移等个人信息权利实现机制。最终用户的个人信息处理请求涉及任意门的，我们将在确认最终用户身份后配合开发者完成个人信息处理。</li>
          <li>开发者应接入/升级至满足监管新规的最新版本。</li>
        </ol>
        <p><span class="emphasis">任意门仅针对成年人。</span>如开发者应用面向未成年人的，开发者应与我们联系，同时，开发者应建立健全未成年人个人信息保护机制，向最终用户列明未成年人个人信息处理规则，未经未成年人的父母或监护人同意的，不得处理其个人信息。
          如我们发现开发者存在违法违规处理个人信息的风险，我们将有权采取关停服务、单方面响应最终用户个人信息处理请求等措施以保障最终用户的个人信息权益。</p>
        <br/>
        <h3>一、我们如何收集和使用您的个人信息</h3>
        <h3>（一）基本业务功能</h3>
        <p>任意门提供的基本业务功能为最终用户提供在平安集团内关联公司开发和/或运营的应用或提供的各类服务内容中进行便捷跳转。</p>
        <p>在实现基本业务功能时，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化您的服务体验，我们会获取您的如下信息。<span class="emphasis">非因前述目的，我们不会对您信息进行留存和处理。如果您拒绝提供下述信息，我们将无法为您提供基础服务，您将无法在开发者应用内便捷的跳转。</span>我们获取的具体信息如下：</p>
        <table border="1" class="privacy-table">
          <thead>
            <tr>
              <!-- 表头 -->
              <th>功能名称</th>
              <th>个人信息种类</th>
              <th>处理目的</th>
              <th>处理方式</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>便捷跳转</td>
              <td>设备型号、操作系统版本、网络信息（读取WIFI状态）、屏幕分辨率、应用版本号、网络请求信息</td>
              <td>为您在平安集团内关联公司开发和/或运营的应用或提供的各类服务内容中进行便捷跳转，这类信息是为提供服务必须收集的基础信息。如，获取屏幕分辨率可以用于适配折叠屏，以便我们更好地展示应用内容</td>
              <td>【SDK系统调用获取】，采取加密、去标识化、匿名化的措施保证您的个人信息安全。<br/>
                我们将在SDK初始化时收集一次，之后根据最终用户主动提交的业务需求，在必要时进行采集更新。</td>
            </tr>
          </tbody>
        </table>
        <p class="emphasis">请注意，单独的设备信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，我们将再次获得您的同意后，依据法律规定进行处理。</p>
        <h3>（二）扩展功能</h3>
        <p>
          任意门可能会不时推出问卷调查、抽奖等自营活动，此类线上活动可能需要您提供您的姓名、电话、电子邮箱、家庭地址信息。<span class="emphasis">（如任意门需在特定的自营活动中收集额外的个人信息，我们将单独提示并征得您的同意，除非该活动存在单独的隐私保护政策，额外收集的个人信息将同样适用本隐私政策的规定），这些信息将作为您参与活动、接收奖品等的凭证。拒绝提供这些信息仅会使您无法参与特定活动，但不影响您正常使用任意门的其他功能。我们会确保搜集数据的最小化和精确性，并采取加密、去标识化、匿名化的措施保证您的个人信息安全。</span>
        </p>
        <h3>（三）个性化推荐服务</h3>
        <p>为了提升最终用户的产品使用体验，在您使用任意门的过程中，我们可能会收集您访问、点击任意门内各类活动的情况用于分析并向您推荐您可能感兴趣的内容。</p>
        <p class="emphasis">如您不希望接收此类个性化服务，您可以在任意门左屏提供的设置功能中，关闭个性化推荐服务，如您关闭此设置，您收到的营销活动通知、商业性电子信息或广告与您的相关度将会降低。</p>
        <h3>（四）第三方信息收集提示</h3>
        <p class="emphasis">任意门旨在为最终用户提供跨平台、跨运营主体间便捷的跳转服务，最终用户可以通过任意门跳转至第三方页面以获取第三方主体提供的活动、产品或服务，跳转后，最终用户所提交的信息均由第三方主体直接获取，最终用户应在提供个人信息前仔细阅读第三方主体的个人信息保护政策，任意门不会收集、使用、存储或截留最终用户直接向第三方主体提供的信息。</p>
        <p>例如，最终用户可通过任意门跳转至第三方主体的线上小游戏、线上问卷调查、产品购买、开通账户等界面，在参与上述活动中，根据活动类型，最终用户可能可以自行上传个人照片作为小游戏头像、通过问卷反馈个人信息、提交问题截图、上传个人证件照以办理账户、填写个人地址和地理位置信息以接受送货服务、上传照片至朋友圈等，该类信息将由最终用户向第三方主体直接提供。</p>
        <p class="emphasis">任意门提示，最终用户应仔细阅读第三方主体的个人信息保护政策，审慎甄别个人信息等方面的安全风险，如认为存在安全风险的，请不要同意相关个人信息保护政策或提供个人信息。</p>
        <h3>（五）系统权限说明</h3>
        <p class="emphasis">使用任意门服务可能涉及到以下权限，我们会根据实际需求向最终该用户进行权限获取请求，在最终用户同意后，我们才会使用相关的功能，如终端用户关闭权限即代表其取消了相应的授权, 我们和开发者将无法继续收集和使用对应的个人信息, 也无法为最终用户提供上述与该等授权所对应的功能。如权限使用目的、场景发生变化，我们将重新向您申请该权限。</p>
        <ol class="list">
          <li>
            <span class="emphasis">摄像头权限：</span>当您使用任意门SDK上投放的产品或服务，例如使用到在线客服功能时需要上传照片描述您的问题， 我们会向您申请获取此权限，以便您进行实时拍摄并上传图片或视频内容。<span class="emphasis">若您选择不开启此权限，您将无法使用图片或视频拍摄相关的功能，但不影响您使用其他服务。</span>
          </li>
          <li>
            <span class="emphasis">相册权限：</span>当您在使用任意门SDK上投放的业务产品或服务并通过任意门上传的您的头像、分享的照片时，我们会向您申请获取此权限，以便您上传设备中的图片或视频。<span class="emphasis">若您选择不开启此权限，您将无法使用图片或视频上传相关的功能，但不影响您使用其他服务。</span>
          </li>
          <li>
            <span class="emphasis">位置信息权限：</span>当您使用与位置有关的服务时，我们可能会申请获取您设备所在的位置信息，以便为您提供相关服务。例如：您需要查询附近的银行网点、附近的加油站时候，我们会向您申请获取此权限，以便向您提供相关信息。
            <span class="emphasis">若您选择不开启此权限，您将无法使用基于位置信息相关的特定功能，但不影响您使用其他服务。</span>
          </li>
          <li>
            <span class="emphasis">网络权限：</span>当您运行任意门SDK时，我们会向您申请获取此权限，用于与服务端进行通讯。<span class="emphasis">若您选择不开启此权限，您将无法使用任意门的相关功能，但不会影响您使用开发者应用。</span>
          </li>
          <li>
            <span class="emphasis">添加桌面权限：</span>当您在使用任意门sdk时，如您需要将当前使用的业务在桌面添加一个快捷方式，则需要申请此权限。<span class="emphasis">如选择不开启此权限，不会影响业务的正常使用，但无法添加桌面快捷方式。</span>
          </li>
          <li>
            <span class="emphasis">麦克风权限：</span>当您运行任意门sdk时，我们可能会向您申请获取麦克风权限权限以便提升服务体验，如您在线客服需要语音输入的场景。<span class="emphasis">若您选择不开启此权限，您将无法使用基于麦克风的语音输入功能，但不影响您使用文字输入使用服务。上述内容需要您在您的设备中同意向我们开启访问权限，以实现这些功能所涉及的信息收集和使用。您确认并同意开启这些权限，我们才会在您使用特定业务功能时，收集和使用为了正常运行该业务功能所必需的信息。</span>
          </li>
          <li>
            <span class="emphasis">传感器权限：</span>当您使用本SDK提供的功能在拍摄照片用于理赔、客服咨询业务时、屏幕自动旋转或运动状态识别等功能时，我们可能需要访问设备的传感器（加速度传感器、陀螺仪、方向传感器、光线传感器），以获取设备的姿态、运动状态、明暗状态等信息。该信息仅在本地处理，用于优化交互体验，不会上传至服务器，亦不用于其他目的。
            <span class="emphasis">若您选择不开启此权限，则无法使用自动补光功能，但不影响手动拍照。
            在您首次使用相关功能前，我们将弹窗提示并征得您的同意，确保在获得授权后才启用传感器访问。您确认并同意开启这些权限，我们才会在您使用特定业务功能时，收集和使用为了正常运行该业务功能所必需的信息。
            您可随时通过对应系统的设置功能，找到对应的APP，选择关闭对应APP的传感器权限。</span>
          </li>
          <li>
            <span class="emphasis">打印权限（鸿蒙）：</span>当您主动发起打印操作时，我们需要访问局域网内的打印设备信息（打印机名称、IP地址、支持格式、打印尺寸、色彩），以实现打印任务的发现与连接。仅在您点击'打印'按钮后，系统才会获取打印权限，仅用于打印场景，不保存、不上传任何信息，也不用于用户追踪或其他用途，并在任务结束后自动释放权限。
            <span class="emphasis">在您首次使用相关功能前，我们将弹窗提示并征得您的同意，确保在获得授权后才启用打印权限访问。您确认并同意开启这些权限，我们才会在您使用特定业务功能时，收集和使用为了正常运行该业务功能所必需的信息。
            若您拒绝此权限，将无法使用打印功能，但不影响其他服务的正常使用。您可随时通过过系统的设置功能，找到对应的APP，选择关闭对应APP的打印权限来停止该功能的数据访问。</span>
          </li>
        </ol>
        <p class="emphasis">同时，您也可以遵循您所使用设备的操作系统指示变更或者取消这些授权或者打开手机设置-找到对应APP-关闭对应授权权限，注意在不同设备和系统中, 权限显示方式及关闭方式可能有所不同, 请终端用户参考其使用的设备及操作系统开发方的说明或指引。</p>
        <h3>（六）依法豁免征得同意收集和使用的个人信息</h3>
        <p>请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</p>
        <ol class="list">
          <li v-for="(item, index) in exemptionContent" :key="index">{{item}}</li>
        </ol>
        <br />
        <h3>二、我们如何共享、转让、公开披露您的个人信息</h3>
        <h3>（一）共享</h3>
        <p>我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
        <ol class="list">
          <li>获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
          <li>法定情形下，我们会根据法律法规规定，或按政府主管部门的强制性要求，如诉讼争议解决需要、行政、司法机构提供的要求，对外共享您的个人信息。</li>
          <li>
            <span class="emphasis">经过您同意后，</span>为了更好地为您提供<span class="emphasis">基本业务功能</span>，履行我们的社会责任与法定义务，同时实现我们的商业价值，我们可能会在平安集团内部与关联公司共享您的个人信息，我们的关联公司包括但不限于：中国平安人寿保险股份有限公司、中国平安财产保险股份有限公司、 平安养老保险股份有限公司、平安健康保险股份有限公司、平安银行股份有限公司、平安资产管理有限责任公司、平安信托有限责任公司、平安证券有限责任公司、平安期货有限公司、平安基金管理有限公司、平安不动产有限公司、平安国际融资租赁有限公司、上海陆家嘴国际金融资产交易市场股份有限公司（陆金所）、平安健康互联网股份有限公司、深圳壹账通智能科技有限公司、平安医疗健康管理股份有限公司、平安壹钱包电子商务有限公司、平安城市建设科技（深圳）有限公司、深圳平安综合金融服务有限公司、平安融易（江苏）融资担保有限公司、平安国际智慧城市科技股份有限公司、深圳前海金融资产交易所有限公司、重庆金融资产交易所有限责任公司、陆金所控股有限公司、平安保险（集团）股份有限公司。（上述关联公司可能会发生变化，请参考年报： <a href="http://www.pingan.cn/ir/financial-report.shtml">http://www.pingan.cn/ir/financial-report.shtml</a>）
            <p>关联公司所涉行业包括：保险、银行、信托、证券、资产管理、财富管理、基金管理、融资租赁、普惠金融、健康医疗等。</p>
            <p><span class="emphasis">基本业务功能系为向您提供产品与服务所必需，或是为防范风险、保障安全、实现合规所必要。</span>请您授权我们进行该等共享，否则我们难以为您提供安全的、统一的服务。具体而言，我们的基本业务功能包括：</p>
            <ul class="ulist">
              <li>为您提供产品与服务：我们可能会共享您必要的个人信息，包括：【手机型号、系统类型】，以便【为您展示适配对应系统的产品和服务】。</li>
              <li>统一用户服务：我们可能共享您必要的个人信息，包括：【手机型号、系统类型、系统版本、网络类型、应用版本】，以便【正确加载和展示内容，确保服务统一】。</li>
              <li>风险防控与安全保障：我们可能共享您必要的个人信息，实现我们在风险防控、防范欺诈、合规内控等方要求，从而在安全的前提下为您提供产品与服务。</li>
              <li>法定义务：我们可能共享您必要的个人信息，履行我们在特殊行业从业人员背景调查等方面的法定义务。</li>
              <li style="font-weight: normal;">在共享您的个人信息之前以及共享的过程中，我们将充分评估该等共享的合法性、正当性、必要性，并采用适当的管理措施与技术措施，以保障您的个人信息安全。平安集团关联公司如果想要改变本隐私政策声明的个人信息使用目的，将再次征求您的授权同意。我们将个人信息保护与数据安全作为数据共享与建模的前提条件，辅以无差别、一体化的管理措施与技术措施作为保障。</li>
                <!-- <a href="https://maam-res.pingan.com.cn/web/PaDailyNews/index.html#/article/A00000012" style="text-decoration: underline;">第三方SDK列表清单</a> -->
            </ul>
          </li>
          <li>
            SDK共享：为了更好地向您提供产品与服务，我们会通过其他的软件开发工具包（SDK））进行必要的数据共享。我们会对接入的SDK进行安全监测，并要求其遵循合作法律协议，采取数据保护措施。您可点击查看<span @click="$router.push('/third')" style="text-decoration: underline;">第三方SDK列表清单</span>，进一步了解SDK的名称、运营方、使用目的、个人信息的类型等具体情况。
          </li>
          <li>
            <span class="emphasis">特别声明：我们会要求第三方SDK服务商遵守适用的法律法规，严格保护您的数据，并采取合理的措施来确保数据的安全性。尽管如此，如果出现与第三方SDK数据收集相关的问题或争议，我们将不承担责任或义务，请查看第三方SDK的隐私政策以了解更多有关他们的数据处理方式和承诺。如果我们发现任何与使用的SDK相关的违规或恶意数据收集情况，我们将采取立即行动，包括但不限于与监管机构合作、要求SDK服务商进行整改，或停止使用该SDK。我们致力于确保您的数据的隐私和安全，并将不容忍违规行为。我们将尽最大努力维护您的权益和数据安全。</span>
          </li>
        </ol>
        <h3>（二）转让</h3>
        <p class="emphasis">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <ul class="list">
          <li>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
          <li class="emphasis">在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会向您告知接收方的名称或者姓名和联系方式，要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
        </ul>
        <h3>（三）公开披露</h3>
        <p class="emphasis">我们一般不会公开披露您的信息，除非取得您的单独同意，或依据法律法规的相关要求。</p>
        <p><span class="emphasis">请注意，您在使用我们的产品/服务的过程中可能会自行公开的一些信息：</span>您通过任意门所跳转的第三方主体平台可能存在信息分享功能，当您在第三方活动使用相关功能时，您可以与您的好友及其他用户分享您的相关信息。例如，您可能可以通过第三方平台公开分享您的照片和视频。<span class="emphasis">请注意，您公开分享的的信息中可能包含您的个人信息。请您谨慎考虑披露您的个人信息。</span></p>
        <p class="emphasis">我们仅会在以下情况下，公开披露您的个人信息：</p>
        <ol class="list">
          <li>获得您明确同意后；</li>
          <li>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>
        </ol>
        <h3>（四）无需您同意的共享、转让、公开披露</h3>
        <p class="emphasis">请您注意，根据法律法规的规定，在以下情形中，我们无需取得您的同意即可共享、转让、公开披露您的个人信息：</p>
        <ol class="list">
          <li>为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</li>
          <li>为履行法定职责或者法定义务所必需；</li>
          <li>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</li>
          <li>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</li>
          <li>依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</li>
          <li>法律、行政法规规定的其他情形。</li>
        </ol>
        <br />
        <h3>三、我们如何存储个人信息</h3>
        <h3>（一）存储地点</h3>
        <p>我们依照法律法规的规定，将在中国境内（香港特别行政区、澳门特别行政区，台湾地区除外）运营过程中收集和产生的您的个人信息存储于境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家或地区的规定或者征求您的同意。</p>
        <h3>（二）存储期限</h3>
        <p>一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
        <p>1）为遵守适用的法律法规等有关规定；</p>
        <p>2）为遵守法院判决、裁定或其他法律程序的规定；</p>
        <p>3）为遵守相关政府机关或法定授权组织的要求；</p>
        <p>4）我们有理由确信需要遵守法律法规等有关规定；</p>
        <p>5）为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途；</p>
        <p>6）当我们的产品或服务发生停止运营的情形时，我们将采取，例如推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。</p>
        <p>在超出存储期限后，我们会依法删除或匿名化处理您的个人信息。如果删除从技术上难以实现的，我们会停止除存储和采取必要的安全保护措施之外的处理活动。</p>
        <br />
        <h3>四、我们如何保护您的个人信息</h3>
        <p>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与"服务"之间交换数据（如信用卡信息）时受 SSL 加密保护；我们同时对任意门SDK上投放的网页提供 https 安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
        <p>（二）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
        <p>（三）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他平台用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。</p>
        <p>（四）我们将定期更新并公开安全风险、个人信息安全影响评估等报告的有关内容。您可通过平安科技平台消息通知获得。</p>
        <p>（五）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
        <p>（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
        <p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
        <br />
        <h3>五、您如何管理自己的信息</h3>
        <p>您对您的个人信息依法享有如下的权利与选择，我们充分尊重您对个人信息的权利和选择，并保障该等权利的行使。</p>
        <p class="emphasis">作为开发者，应当为最终用户提供并明确其查阅、复制、更正、补充、删除个人信息、撤回或改变授权同意范围和注销账号的方式。</p>
        <p>请您理解，任意门并不直接面对最终用户，向开发者提出个人信息请求或设置开发者应用的权限功能可能是最终用户行使个人信息权利更为便捷的形式：</p>
        <ul class="list">
          <li>您可通过本隐私政策了解产品对您的个人信息的收集、使用等情况；</li>
          <li>您可通过第三方应用程序提供的用户界面进行授权同意或撤回授权同意的个人信息提供范围；</li>
          <li>您可通过第三方应用程序提供的用户界面进行个人信息的查阅、复制、更正、补充、删除、注销账号；</li>
        </ul>
        <p>但最终用户仍可以发送电子邮件至如下地址以直接向我们行使个人信息权利：请注明您的个人信息权利行使需求。</p>
        <p>邮件地址：PUB_KJRYMSDKZX@pingan.com.cn</p>
        <p>一般来说我们将在【15】个工作日内反馈。</p>
        <p>（一）您行使您的上述权利需要提供书面请求，我们可能会要求您进行身份验证，以保障个人信息的安全。</p>
        <p>（二）对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
        <p>（三）在以下情形中，我们可能无法响应您的请求：</p>
        <p>1) 与个人信息控制者履行法律法规规定的义务相关的；</p>
        <p>2) 与国家安全、国防安全直接相关的；</p>
        <p>3) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>4) 与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>
        <p>5) 个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
        <p>6) 响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
        <p>7) 涉及商业秘密的；</p>
        <p>8) 法律法规规定的其他情形。</p>
        <p class="emphasis">请您注意，当您执行上述操作后，我们将无法继续为您提供对应的服务，但这不会影响此前基于您的授权而进行的个人信息处理活动。</p>
        <p class="emphasis">如果我们的最终用户不幸逝世，您作为近亲属，为了自身的合法、正当利益，您可以依法对逝者的相关个人信息行使查阅、复制、更正、删除等权利，除非逝者生前另有安排。请通过上文描述的邮箱向我们提出请求。为了保护逝者的个人信息，我们需要您协助提交相应的证明文件。</p>
        <br />
        <h3>六、我们如何处理未成年人的个人信息</h3>
        <p>任意门仅针对成年用户，未成年用户请勿直接使用任意门，如您发现我们收集了未成年人的个人信息的，请及时与我们联系，我们将及时删除或匿名化处理相关信息。</p>
        <p>如果我们发现在未事先获得未成年人的父母或法定监护人同意的情况下收集了未成年人的个人信息，会立即删除相关数据。</p>
        <br />
        <h3>七、本政策如何更新</h3>
        <p class="indent">随着我们的业务、产品与服务的完善与变化，本政策也可能随之变更。<span class="emphasis">对于本政策的重大变更，我们将会以恰当的方式通知您，例如，弹窗、推送、公告、邮件、或其他符合法律要求的适当形式。未经您的知情和同意（如适用），我们不会削减您按照本政策所享有的权利。</span>本政策所指的重大变更包括但不限于：</p>
        <ol class="list">
          <li>我们的业务、产品或服务的模式发生重大变化，影响到个人信息的处理目的、处理方式、处理的个人信息种类；</li>
          <li>我们在所有权结构、组织架构等方面发生重大变化，导致处理个人信息的主体发生变化；</li>
          <li>个人信息共享、转让、公开披露的主要对象发生变化；</li>
          <li>您行使个人信息权利的方式和程序发生重大变化；</li>
          <li>我们的个人信息保护团队、个人信息保护负责人的联系方式发生变化；</li>
          <li>我们的个人信息保护影响评估提示存在高风险；</li>
          <li>其他可能对您的个人权益有重大影响的情形。</li>
        </ol>
        <p class="emphasis">若您不同意该等变更可以停止使用我们的产品和服务。</p>
        <p class="emphasis">在我们更新后的政策对处理最终用户的个人信息情况有重大变化的，开发者应当适时更新隐私政策，并通知最终用户并且获得其同意，如果最终用户不同意接受本规则, 请停止本服务。</p>
        <br />
        <h3>八、如何联系我们</h3>
        <p>我们设立了专门的个人信息保护团队和个人信息保护负责人，如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：</p>
        <p>邮箱地址：<span class="line emphasis">PUB_KJRYMSDKZX@pingan.com.cn。</span></p>
        <p>一般情况下，我们将在15个工作日内回复。</p>
        <br />
        <h3>附录：相关定义</h3>
        <p class="indent">为了帮助您更好地理解本政策，我们在附录中向您介绍以下专有名词的定义与示例。</p>
        <p class="indent"><span class="emphasis">个人信息：</span>指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。例如：</p>
        <img src="@/assets/images/personal.png" />
        <p class="indent"><span class="emphasis">敏感个人信息：</span>指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。例如，生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
        <p class="indent"><span class="emphasis">设备信息：</span>包括设备标识符（IMEI、IDFA、AndroidID、MAC、OAID、IMSI及其他设备相关信息）、应用信息（应用崩溃信息、通知开关状态、应用安装列表及其他应用相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、设备网络环境信息（IP地址、Wi-Fi信息、基站信息及其他网络相关信息）等。具体以产品/服务的实际情况为准。</p>
        <p class="indent"><span class="emphasis">日志信息：</span>包括浏览记录、点击查看记录、搜索查询记录、收藏记录、添加至购物车记录、关注分享信息、发布信息、IP地址、浏览器的类型、使用的语言、操作系统的版本、访问的日期和时间、电信运营商等。具体以产品/服务的实际情况为准。</p>
        <p class="indent"><span class="emphasis">去标识化：</span>指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。去标识化处理后的信息仍属于个人信息。</p>
        <p class="indent"><span class="emphasis">匿名化：</span>指个人信息经过处理无法识别特定自然人且不能复原的过程。匿名化处理后的信息不再属于个人信息。</p>
        <p class="indent"><span class="emphasis">处理：</span>包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。</p>
        <p class="indent"><span class="emphasis">开发者：</span>指在自身产品或服务中集成、调用或依赖特定技术组件（如"任意门"）的公司、组织、个人及其他主体。</p>
        <p class="indent"><span class="emphasis">开发者应用/第三方应用程序：</span>指由开发者（公司、组织或个人）开发、运营或实际控制的，集成特定技术服务（如"任意门"产品）并向用户提供功能或服务的数字化载体，包括但不限于：移动端应用（iOS/Android APP）、Web 应用（网页、H5 页面）、小程序（微信、支付宝等平台内的轻量化应用）、公众号（社交媒体账号及关联服务）。</p>
        <p class="indent"><span class="emphasis">最终用户：</span>指实际使用开发者应用的自然人个体，具备以下特征：直接接触应用界面并与之互动；其个人信息被开发者应用收集、储存或利用；能够行使《个人信息保护法》赋予的各项权利主体。</p>
      </div>
    </div>
  </template>
  
  <script>
  import RymApp from "@/utils/native";
  export default {
    name: "PrivacyV3",
    data() {
      return {
        policyContent: [
          "我们如何收集和使用您的个人信息",
          "我们如何共享、转让、公开披露您的个人信息",
          "我们如何存储个人信息",
          "我们如何保护您的个人信息",
          "您如何管理自己的信息",
          "我们如何处理未成年人的个人信息",
          "本政策如何更新",
          "如何联系我们"
        ],
        definitionContent: [
          "个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人相关的各种信息。",
          "开发者：指在自身产品或服务中集成任意门的公司、组织、个人或其他主体。",
          "开发者应用：开发者开发和/或运营的、集成了任意门产品的应用，包括但不限于APP、网页、小程序、公众号等。",
          "最终用户：指开发者应用所面向的终端自然人用户。"
        ],
        exemptionContent: [
          "为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；",
          "为履行法定职责或者法定义务所必需；",
          "为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；",
          "为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；",
          "依据法律规定，在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；",
          "法律、行政法规规定的其他情形。"
        ]
      };
    },
    created() {
      RymApp.track("隐私协议", "首页曝光");
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .wrapper {
    overflow-x: hidden;
    font-size: 14px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    padding: 20px;
    line-height: 2em;
    color: #333;
    text-align: justify;
    word-break: break-all;
    .mainTitle {
      font-size: 18px;
      text-align: center;
    }
    h3 {
      margin: 5px 0;
      font-size: 15px;
    }
    p.indent {
      text-indent: 2em;
    }
    .content {
      margin-top: 20px;
      .line {
        text-decoration: underline;
      }
      .list {
        list-style: decimal;
        list-style-position: inside;
        padding: 5px 0;
      }
      .ulist {
        font-weight: bold;
        list-style: none;
        list-style-position: inside;
      }
      ::v-deep .emphasis {
        font-weight: bold;
      }
      .company {
        text-align: right;
      }
    }
    .privacy-table {
      border-collapse: collapse;
      margin-top: 20px;
      th, td {
        border: 1px solid #ccc;
        padding: 8px;
        text-align: center;
        word-break: break-all;
        width: 10%;
      }
    }
  }
  </style>
